<template>
  <div class="edit-image-group">
    <!-- Contentタブ -->
    <div v-if="showTabContent">
      <image-edit
        v-for="part in imageParts"
        :key="part.id"
        :current="current"
        :part="part"
        :partsContainerId="partsContainerId"
        :sectionId="sectionId"
        :partsContainerType="partsContainerType"
      />
    </div>
    <!-- Styleタブ -->
    <div v-if="showTabStyle">
      <!-- スタイル編集 -->
      <image-edit
        :current="current"
        :part="parts[0]"
        :partsContainerId="partsContainerId"
        :sectionId="sectionId"
        :partsContainerType="partsContainerType"
        :partsContainerStyles="partsContainerStyles"
      />
    </div>
    <!-- 設定タブ -->
    <div v-if="showTabSetting">
      <!-- レイアウト変更 -->
      <layout-edit
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :imageCount="imageParts.length"
        :partsContainerStyles="styles"
        :spacerParts="spacerParts"
        :flgSide="flgSide"
        :flgImageContentMobileFullWidth="flgImageContentMobileFullWidth"
      />
      <!-- パーツの背景色 -->
      <edit-parts-container-style
        v-if="showTabSetting"
        :styles="partsContainerStyles"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
      />
    </div>
  </div>
</template>

<script>
import EditPartsContainerStyle from '@/components/Content/Palette/EditPartDesign/Layouts/PartsContainerStyle'
import ImageEdit from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageEdit'
import LayoutEdit from '@/components/Content/Palette/EditPartDesign/Editor/ImageGroup/ImageGroupLayout'

export default {
  props: [
    'current',
    'styles',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'partsContainerStyles',
    'firstPartStyles',
    'flgSide',
    'flgImageContentMobileFullWidth',
  ],
  components: {
    EditPartsContainerStyle,
    ImageEdit,
    LayoutEdit,
  },
  computed: {
    imageParts () {
      if (!this.parts) return null
      return this.parts.filter(part => part.type !== 'Spacer')
    },
    spacerParts () {
      if (!this.parts) return null
      return this.parts.filter(part => part.type === 'Spacer')
    },
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    // watch で監視するため、代表で最初のパーツのスタイルを取得
    firstPartStyleBorder () {
      if (!this.firstPartStyles) return null
      return this.firstPartStyles['border-top']
    },
    firstPartStyleBorderRadius () {
      if (!this.firstPartStyles) return null
      return this.firstPartStyles['border-radius']
    },
  },
  methods: {
    // 最初のパーツのスタイルが更新されたら、他のパーツにも同じスタイルを適用させる
    updatePartsStyle (prop, value) {
      let firstPartStyles
      if (prop === 'border') {
        firstPartStyles = {
          'border-top': value,
          'border-right': value,
          'border-bottom': value,
          'border-left': value,
        }
      } else if (prop) {
        firstPartStyles = {
          [prop]: value
        }
      }
      // 最初のパーツを飛ばして、インデックス1番からループさせる
      for (let count = 1; count <= this.parts.length - 1; count++) {
        this.$store.commit('updatePart', {
          sectionId: this.sectionId,
          partsContainerId: this.partsContainerId,
          partId: this.parts[count].id,
          styles: firstPartStyles,
        })
      }
      // 画像の表示サイズ調整
      this.$store.commit('updateImagePartDisplaySize', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
      })
    }
  },
  watch: {
    firstPartStyleBorder (value) {
      this.updatePartsStyle('border', value)
    },
    firstPartStyleBorderRadius (value) {
      this.updatePartsStyle('border-radius', value)
    },
  }
}
</script>

<style lang="scss">
.edit-image-group {
  .layouts-parts-container-style {
    .edit-style-select-color {
      .window {
        // パーツの背景色カラーピッカー
        top: -275px;
      }
    }
  }
}
</style>
